import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  ManualRolloverContextProvider,
} from 'Views/Page/Content/Templates/ManualRolloverTemplate/ManualRolloverContext';
import ManualRolloverTemplate from 'Views/Page/Content/Templates/ManualRolloverTemplate/template';


const Container = ({
  resource,
}) => {
  return (
    <ManualRolloverContextProvider resource={resource}>
      <ManualRolloverTemplate />
    </ManualRolloverContextProvider>
  );
};

Container.defaultProps = {
};

Container.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default Container;
